import { gql } from '@apollo/client'

export const ClientQuery = gql`
  query Client($companyId: ID!, $filters: ClientFilters) {
    clients(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        organisationName
        address
        clientType {
          id
          name
          color
        }
        events {
          nodes {
            id
            totalCents
            eventLength
          }
        }
        phone
        email
        eventsCount
        totalRevenue
        totalEventDiscounts
        eventLengthTotal
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
